import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { withSiteMap, processor, findSiteMap, siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { DefaultScopeProvider } from '@bingads-webui-react/scope-service';
import { Scope } from '@bingads-webui-campaign-react/shell-ui-common';

const ScopeProviderInternal = (props) => {
  const {
    defaultScope, siteMap, permissions, ...others
  } = props;

  // if current page supports customer scope, no need to auto-fill aid
  const customerScopedItem = findSiteMap(siteMap, (mapItem) => {
    if (mapItem.selected) {
      const itemScope = _.isFunction(mapItem.scope) ? mapItem.scope(permissions) : mapItem.scope;
      return itemScope.indexOf(Scope.Customer) > -1;
    }

    return false;
  });

  const scope = _.isEmpty(customerScopedItem) ? defaultScope : _.omit(defaultScope, 'aid');

  return (<DefaultScopeProvider scope={scope} {...others} />);
};

ScopeProviderInternal.propTypes = {
  defaultScope: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  siteMap: siteMapPropType.isRequired,
  permissions: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.objectOf(PropTypes.bool),
    PropTypes.number,
  ])).isRequired,
};

ScopeProviderInternal.defaultProps = {
  defaultScope: {},
};

export const ScopeProvider = withPermissions(withSiteMap(React.memo(ScopeProviderInternal), [processor.processPath]));
